const COMMON_CONTAINER_ID = 'COMMON_CONTAINER_ID';
const LIMITED_CONTAINER_ID = 'LIMITED_CONTAINER_ID';
const CRITICAL_ERROR_TOAST_ID = 'CRITICAL_ERROR_TOAST_ID';
const INFO_TOAST_ID = 'INFO_TOAST_ID';

export {
  COMMON_CONTAINER_ID,
  LIMITED_CONTAINER_ID,
  CRITICAL_ERROR_TOAST_ID,
  INFO_TOAST_ID,
};
